import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(1.5),

    '&:last-child': {
      paddingBottom: 0,
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1, 2),
  },

  icon: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    marginRight: theme.spacing(1.5),

    '& img': {
      height: '100%',
    },
  },

  user: {
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },

  title: {
    fontSize: theme.spacing(2.5),
    textTransform: 'uppercase',
    fontFamily: 'Bebas Neue',
  },

  userValueContainer: {
    display: 'grid',
    paddingLeft: theme.spacing(1),
  },
  username: {
    fontSize: theme.spacing(2),
    paddingRight: theme.spacing(1),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  value: {
    fontSize: theme.spacing(2.5),
    textTransform: 'uppercase',
    fontFamily: 'Bebas Neue',
    color: theme.palette.primary.light,
    fontWeight: 'bold',
  },

  rankContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    height: theme.spacing(5),
  },

  rankIcon: {
    fontSize: theme.spacing(3),
    paddingTop: theme.spacing(0.125),
  },

  rank: {
    fontSize: theme.spacing(2),
    textTransform: 'uppercase',
    fontFamily: 'Bebas Neue',
    lineHeight: 1,
  },
}));
